import React from 'react';
import headerLogo from './images/daniRepassesLogo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import Helmet from "react-helmet";
import favicon from "./images/favicon.png";

class Header extends React.Component {

    render() {

        return (
            <React.Fragment>

                <Helmet>
                    <title> Dani Repasse Floripa</title>
                    <link rel="icon" href={favicon} type="image/x-icon"/>
                    <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                    <meta name="description"
                          content="Temos o melhor estoque de Repasses da Grande Floripa. Estamos à 18 anos no mercado com centenas de clientes satisfeitos. Venha conferir e receber as melhores ofertas!"/>
                </Helmet>

                <header>
                    <div className="container">
                        <div className="row" id="rowTop">
                            <nav className="nav navbar navbar-expand-lg navbar-light headerContents">

                                <a href={'/'} className="navbar-brand navLogo">
                                    <img src={headerLogo} alt="logo" id="logo"/>
                                </a>

                                <div className="col-md-5 collapse navbar-collapse navLinks">
                                    <a className="nav-link" href="/">Início</a>
                                    <a className="nav-link" href="/pesquisa">Estoque</a>
                                    <a className="nav-link" href="/avaliacao">Venda Seu Carro Aqui</a>
                                    <a className="nav-link" href="/contato">Dúvidas e Informações</a>
                                    <a className="nav-link" href="/sobre-nos">Quem Somos</a>
                                </div>

                                <button className="navbar-toggler navToggler" type="button" data-toggle="collapse"
                                        data-target="#navbarNavDropdown" aria-controls="navbarNav" aria-expanded="false"
                                        aria-label="Toggle navigation">
                                    <FontAwesomeIcon icon={faBars} size={"2x"} className={"barIcon"} />
                                </button>
                            </nav>
                        </div>
                    </div>

                    <div className="row sepBar"> </div>
                    <div>
                        <div className="collapse navbar-collapse navbarNavDropdown" id="navbarNavDropdown">
                            <a className="nav-link" href="/">Inicio</a>
                            <a className="nav-link" href="/pesquisa">Estoque</a>
                            <a className="nav-link" href="/avaliacao">Venda Seu Carro Aqui</a>
                            <a className="nav-link" href="/contato">Dúvidas e Informações</a>
                            <a className="nav-link" href="/sobre-nos">Quem Somos</a>
                        </div>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

export default Header;